import * as styles from "./styles.css";
import Strings from "../../../utils/hardcoded.json";
export const PartnerBanner = ({ dismissPartnerBanner, subscriptionType, }) => {
    const renderMsgs = () => {
        const renderProviderApp = () => {
            switch (subscriptionType) {
                case "Google":
                case "Amazon":
                    return `via an ${subscriptionType} in App subscription`;
                case "Apple":
                    return `via an Apple in App subscription`;
                default:
                    return "directly";
            }
        };
        const renderProviderStore = () => {
            switch (subscriptionType) {
                case "Google":
                    return `Google Play.`;
                case "Apple":
                    return "iTunes.";
                case "Amazon":
                    return "Amazon.";
                default:
                    return "App.";
            }
        };
        const via = renderProviderApp();
        const store = renderProviderStore();
        const str = Strings.AFFILIATE_MESSAGE + via + Strings.CANCEL_MSG + store;
        return str;
    };
    const bannerMsg = renderMsgs();
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.text }, bannerMsg),
        React.createElement("div", { className: styles.okContainer, onClick: dismissPartnerBanner }, Strings.OK)));
};

